<script setup lang="ts">
import ArrowRightIcon from '@/assets/icons/ArrowRightIcon.vue';
import IconButton from '@/core/elements/IconButton.vue';
import { IGenericUser } from '@/interfaces';
import { EIcon } from 'common/enum/misc.enum';
import { computed, toRefs } from 'vue';
import UserCard from '../UserCard.vue';

const emit = defineEmits<{
  'click:add': [value: IGenericUser];
  'click:remove': [value: IGenericUser];
  'click:link': [value: IGenericUser];
}>();

const props = defineProps<{
  user: IGenericUser;
  type: 'add' | 'remove' | 'plain' | 'link';
  disabled?: boolean;
  surface?: 'primary' | 'secondary';
  hideEmail?: boolean;
}>();
const { user, type, disabled, surface } = toRefs(props);

const isInvitation = computed(() => user.value.isInvitation === true);
const surfaceClass = computed<string>(() => {
  return surface.value === 'primary' ? 'bg-surface-primary' : 'bg-surface-secondary';
});
</script>

<template>
  <div class="list-item-base rounded-md" :class="[surfaceClass, { 'state-effects': type !== 'plain' }]">
    <UserCard :user="user" class="min-w-0 flex-1">
      <span v-if="!isInvitation && !hideEmail" :title="user.email ?? ''" class="block min-w-0 max-w-full truncate">
        {{ user?.email }}
      </span>

      <div v-if="isInvitation" class="text-muted">
        {{ $t('user.table.invitationPending') }}
      </div>
    </UserCard>

    <IconButton
      v-if="type === 'add' && !disabled"
      :icon-name="EIcon.PLUS"
      theme="primary-filled"
      class="h-button w-button"
      @click="emit('click:add', user)"
    />
    <IconButton
      v-if="type === 'remove' && !disabled"
      :icon-name="EIcon.X"
      theme="secondary"
      class="h-button w-button"
      @click="emit('click:remove', user)"
    />
    <ArrowRightIcon v-if="type === 'link'" class="size-icon text-tint shrink-0" />
  </div>
</template>
